import React from 'react';
import './FormPane.css';
import {Subject} from 'rxjs';
import {
    Form_TextField, Form_Button, Form_Static, Form_Select, Form_Time, Form_Date,
    Form_Radio_Group, Form_MultiSelect, Form_DateTime, Form_Checkbox, Form_Button_Dropdown,
    Form_ToggleButton, Form_UserSelect, Form_WeekSelection, Form_Header, Form_SingleWeekSelection
} from './SubComponents/index';

import SampleForm from './sampleForm';

export function FormPane(props) {
    let {formStructure = null, formSubject = new Subject(), initialFormData = {}} = props
    if (formStructure === null) {
        formStructure = SampleForm;
    }

    // this corrects any missing keys
    formStructure.map((fs, index) => {
        if (fs.key === undefined || fs.key === null) {
            fs.key = `input_field_${index}`;
        }
    })

    const [localFormState, __setLocalFormState__] = React.useState(initialFormData);
    const setLocalFormState = (obj) => {
        // set the value in the localFormState
        __setLocalFormState__(obj);

        // push the value to the formSubject
        formSubject.next(obj);
    }

    // TODO: hope this actually does what its supposed to.
    formSubject.subscribe((nv) => {
        __setLocalFormState__(nv);
    });

    return (<>
        <div className="FormPane">
            <div className="row">
                {formStructure.map((item, index) => {
                    let key = item.key;
                    if (key === undefined){
                        key = `input_field_${index}`;
                        // console.warn("Items in array without key!!");
                    }
                    // console.log(key);
                    const formItemInput = {...props, item, localFormState, setLocalFormState, key};
                    return (
                        <div key={key} className={`col-${item.size.default}`}>
                            {
                                {
                                    'text': (<Form_TextField {...formItemInput} />),
                                    'button': (<Form_Button {...formItemInput} />),
                                    'select': (<Form_Select {...formItemInput} />),
                                    'multi-select': (<Form_MultiSelect {...formItemInput} />),
                                    'time': (<Form_Time {...formItemInput} />),
                                    'date': (<Form_Date {...formItemInput} />),
                                    'datetime': (<Form_DateTime {...formItemInput} />),
                                    'radio-group': (<Form_Radio_Group {...formItemInput} />),
                                    'checkbox': (<Form_Checkbox {...formItemInput} />),
                                    'toggle-button': (<Form_ToggleButton {...formItemInput} />),
                                    'btn-dropdown': (<Form_Button_Dropdown {...formItemInput} />),
                                    'static': (<Form_Static {...formItemInput} />),
                                    'user-select' : (<Form_UserSelect  {...formItemInput} />),
                                    'week-select' : (<Form_SingleWeekSelection  {...formItemInput} />),
                                    'week-filter' : (<Form_WeekSelection  {...formItemInput} />),
                                    'header' : (<Form_Header  {...formItemInput} />),
                                    'spacer': null,
                                }[item.type]
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    </>);

}
